import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Auth } from 'aws-amplify';

// パブリックパスの定義をインポート
import { PUBLIC_PATHS } from '../contexts/AuthContext';

const RequireAuth = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      // 現在のパスがパブリックパスかチェック
      const isPublicPath = PUBLIC_PATHS.some(path => 
        location.pathname.startsWith(path)
      );

      // パブリックパスの場合は認証チェックをスキップ
      if (isPublicPath) {
        setLoading(false);
        return;
      }

      try {
        const currentUser = await Auth.currentAuthenticatedUser();
        setUser(currentUser);
        setLoading(false);
      } catch (error) {
        history.push('/signin');
      }
    };

    checkAuth();
  }, [history, location]);

  if (loading) return <p>Loading...</p>;

  // パブリックパスまたはユーザーが認証済みの場合はchildrenを表示
  const isPublicPath = PUBLIC_PATHS.some(path => 
    location.pathname.startsWith(path)
  );

  return isPublicPath || user ? children : null;
};

export default RequireAuth;
